import ExcelFormatPage from './excel-format-page';

export default ExcelFormatPage;